import { createFileRoute, redirect } from "@tanstack/react-router";

// The portal opens on the shipments.
export const Route = createFileRoute("/_portal/")({
  beforeLoad: () => {
    throw redirect({ to: "/shipments" });
  },
});
